import { render } from "./TalkRoomCount.vue?vue&type=template&id=4f550b4a&ts=true"
import script from "./TalkRoomCount.vue?vue&type=script&lang=ts&setup=true"
export * from "./TalkRoomCount.vue?vue&type=script&lang=ts&setup=true"

import "./TalkRoomCount.vue?vue&type=style&index=0&id=4f550b4a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/talkRoom/TalkRoomCount.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f550b4a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f550b4a', __exports__)) {
    api.reload('4f550b4a', __exports__)
  }
  
  module.hot.accept("./TalkRoomCount.vue?vue&type=template&id=4f550b4a&ts=true", () => {
    api.rerender('4f550b4a', render)
  })

}


export default __exports__